import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';
import { SearchInput } from 'components';
import Grid from '@material-ui/core/Grid';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    display: 'flex',
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  search: {
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1)
  },
  componentsSearch: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  }
}));

const VisitaFiliadoToolbar = props => {
  const { className, filterVisitaFiliados, setOpenImpressao, setOpenRelatorioFiliados, ...rest } = props;
  const [descricaoFiliado, setDescricaoFiliado] = useState('');
  const [dataEntradaInicial, setDataEntradaInicial] = useState(null);
  const [dataEntradaFinal, setDataEntradaFinal] = useState(null);
  const [dataSaidaInicial, setDataSaidaInicial] = useState(null);
  const [dataSaidaFinal, setDataSaidaFinal] = useState(null);
  const classes = useStyles();
  const [visitaEncerrada, setVisitaEncerrada] = React.useState(null);
  const [modoAnonimo, setModoAnonimo] = useState(false);

  useEffect(() => {
    const anonimo = JSON.parse(localStorage.getItem('modoAnonimo'));
    setModoAnonimo(anonimo);
  }, []);

  const handleChangeRadio = event => {
    console.log(event.target.value);
    setVisitaEncerrada(event.target.value);
  };

  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <div className={classes.componentsSearch}>
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <SearchInput
              className={classes.searchInput}
              placeholder="Pesquise pela descrição do filiado"
              onChange={e => setDescricaoFiliado(e.target.value)}
            />
          </Grid>
          <Grid item md={1} xs={12}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Visita encerrada?</FormLabel>
              <RadioGroup
                row
                aria-label="gender"
                name="gender1"
                value={visitaEncerrada}
                onChange={handleChangeRadio}>
                <FormControlLabel
                  value="true"
                  control={<Radio />}
                  label="Sim"
                />
                <FormControlLabel
                  value="false"
                  control={<Radio />}
                  label="Não"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item md={2} xs={12}>
            <Button
              style={{ width: '100%' }}
              color="primary"
              variant="outlined"
              onClick={e => setOpenImpressao(true)}>
              Relatório
            </Button>
          </Grid>
          {setOpenRelatorioFiliados && (
            <Grid item md={3} xs={12}>
              <Button
                style={{ width: '100%' }}
                color="primary"
                variant="outlined"
                onClick={e => setOpenRelatorioFiliados(true)}>
                Frequência Filiados
              </Button>
              
            </Grid>
          )}

          {!modoAnonimo && (
            <Grid item md={4} xs={12}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    fullWidth
                    margin={'none'}
                    inputVariant="outlined"
                    orientation="landscape"
                    id="dataSaidaInicial"
                    label="Data de saída inicial"
                    helperText={'Data de saída inicial'}
                    format="dd/MM/yyyy"
                    size="small"
                    value={dataSaidaInicial}
                    onChange={setDataSaidaInicial}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                    InputAdornmentProps={{ position: 'end' }}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>
          )}
          {!modoAnonimo && (
            <Grid item md={4} xs={12}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    fullWidth
                    margin={'none'}
                    inputVariant="outlined"
                    orientation="landscape"
                    id="dataSaidaFinal"
                    label="Data de saída final"
                    helperText={'Data de saída final'}
                    format="dd/MM/yyyy"
                    size="small"
                    value={dataSaidaFinal}
                    onChange={setDataSaidaFinal}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                    InputAdornmentProps={{ position: 'end' }}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
            </Grid>
          )}
          <Grid item md={modoAnonimo ? 12 : 4} xs={12}>
            <Button
              style={{ width: '100%' }}
              color="primary"
              variant="contained"
              onClick={e =>
                filterVisitaFiliados(
                  descricaoFiliado,
                  dataEntradaInicial
                    ? moment(dataEntradaInicial).format('YYYY-MM-DD')
                    : null,
                  dataEntradaFinal
                    ? moment(dataEntradaFinal).format('YYYY-MM-DD')
                    : null,
                  dataSaidaInicial
                    ? moment(dataSaidaInicial).format('YYYY-MM-DD')
                    : null,
                  dataSaidaFinal
                    ? moment(dataSaidaFinal).format('YYYY-MM-DD')
                    : null,
                  visitaEncerrada
                )
              }>
              Pesquisar
            </Button>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default VisitaFiliadoToolbar;
